import { useEffect, useState } from 'react'

import CreateReport from './CreateReport'
import useTranslations from '../../../hooks/useTranslations'
import ANTDBreadcrumb from '../../../shared/antd/ANTDBreadcrumb'
import ANTDButton from '../../../shared/antd/ANTDButton'
import ANTDTable from '../../../shared/antd/ANTDTable'
import { dayJs, SAVE_FORMAT } from '../../../utils/dayjs'
import { length } from '../../../utils/javascript'
import { getSaveColumnListApi, getSingleReportApi } from '../report.api'

const SavedReports = () => {
  const { t } = useTranslations()
  const [editMode, setEditMode] = useState({ flag: false, reportData: {} })
  const [dataSource, setDataSource] = useState([])
  const [loader, setLoader] = useState(false)

  const getSingleReportAPI = async ({ rowData }) => {
    const response = await getSingleReportApi({ params: rowData?.id })
    if (response?.data) {
      setEditMode({ flag: true, reportData: response?.data })
    }
  }

  // const {
  //   vehicleCategory,
  //   vehicleProducer,
  //   vehicleModel,
  //   vehicleSource,
  //   vehicleType,
  //   dateOfReceiptOfVehicle,
  //   vehicleStatus,
  //   dealerName,
  //   dealerLocation,
  //   dealerChannel,
  //   dateOfProcessing,
  //   dateOfReceiptOfVehicleAtCollectionCenter,
  // } = filterKeys

  const columns = [
    {
      key: 'user_Name',
      title: t('user_Name'),
      render: rowData => {
        return (
          <ANTDButton
            type="link"
            onClick={() => getSingleReportAPI({ rowData })}
          >
            {rowData?.name}
          </ANTDButton>
        )
      },
    },
    {
      key: 'inv_Description',
      title: t('inv_Description'),
      dataIndex: 'description',
      render: rowData => rowData || '-',
    },
    {
      key: 'job_CreatedBy',
      title: t('job_CreatedBy'),
      dataIndex: 'ownedByUserInfo',
      render: rowData => rowData?.businessName || rowData?.name || '-',
    },
    {
      key: 'inv_DateOfCreation',
      title: t('inv_DateOfCreation'),
      dataIndex: 'creationDate',
      render: rowData => {
        return rowData ? dayJs(rowData).format(SAVE_FORMAT) : '-'
      },
    },
  ]

  // const dataSource = [
  //   {
  //     name: 'Report 1',
  //     description: 'Report Description',
  //     createdBy: 'Praveen',
  //     dateOfCreation: '2025/01/01',
  //     columns: [
  //       'rpt_MSTIVehicleNumber',
  //       'user_ProducerName',
  //       'job_QuotedPrice',
  //       'job_DealerName',
  //       'inv_Location',
  //       'user_Channel',
  //       'job_ConsumerName',
  //       'inv_CollectionCenterName',
  //       'job_DateOfRegistration',
  //     ],
  //     filters: {
  //       [vehicleCategory]: ['3W', '4W'],
  //       [vehicleProducer]: ['Maruti Suzuki', 'Honda'],
  //       [vehicleModel]: ['Swift', 'Alto'],
  //       [vehicleSource]: ['Dealer', 'Direct Individual'],
  //       [vehicleType]: ['ELV'],
  //       [vehicleStatus]: [],
  //       [dealerName]: [],
  //       [dealerLocation]: [],
  //       [dealerChannel]: [],
  //     },
  //     dateRange: {
  //       [dateOfReceiptOfVehicle]: ['2025/01/01', '2025/01/31'],
  //       [dateOfProcessing]: [],
  //       [dateOfReceiptOfVehicleAtCollectionCenter]: [
  //         '2025/01/01',
  //         '2025/01/31',
  //       ],
  //     },
  //   },
  // ]

  useEffect(() => {
    getSaveReportList({ pageNo: 1 })
  }, [])

  const getSaveReportList = async ({ pageNo = 1 }) => {
    setLoader(true)
    const response = await getSaveColumnListApi({
      params: { type: 'FLEXIBLE_REPORT' },
      pageNo,
    })
    if (response?.data) {
      setDataSource(response?.data)
    }
    setLoader(false)
  }

  const handleTableChange = pagination => {
    getSaveReportList({ pageNo: pagination?.current })
  }

  const PAGE_SIZE = 10
  const { list = [], lastPage, pageNo } = dataSource || {}

  return (
    <>
      {editMode.flag ? (
        <>
          <ANTDBreadcrumb
            items={[
              {
                title: (
                  <p
                    className="cursor-pointer primary-color"
                    onClick={() => setEditMode({ flag: false, reportData: {} })}
                  >
                    {t('rpt_SavedReports')}
                  </p>
                ),
              },

              {
                title: editMode.reportData.name,
              },
            ]}
          />

          <CreateReport editData={editMode.reportData} />
        </>
      ) : (
        <ANTDTable
          className="mt-15"
          tableLayout="fixed"
          columns={columns}
          loading={loader}
          dataSource={
            length(list)
              ? list?.map(item => ({
                  ...item,
                  key: item?.id,
                }))
              : []
          }
          pagination={{
            lastFetched: pageNo,
            current: pageNo,
            pageSize: PAGE_SIZE,
            total: lastPage * PAGE_SIZE,
            responsive: true,
            hideOnSinglePage: true,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`,
          }}
          scroll={{ x: 'max-content' }}
          onChange={handleTableChange}
        />
      )}
    </>
  )
}

export default SavedReports
